import { makeStyles } from 'tss-react/mui';
import { theme } from '../../theme';

/**
 * useNotificationsPageStyles defines the styles for the NotificationsPage component.
 */
const useNotificationsPageStyles = makeStyles()(() => ({
  notificationsBox: {
    width: '60%',
    margin: 'auto',
  },
  btns: {
    marginRight: '15%',
  },
  btn: {
    'fontFamily': theme.fontFamily,
    'borderRadius': '20px',
    'backgroundColor': theme.background.paper,
    'color': theme.text.primary.light,
    '&.Mui-selected': {
      'color': theme.text.primary.dark,
      'backgroundColor': theme.primary.light,
      '&:hover': {
        color: theme.text.primary.dark,
        backgroundColor: theme.primary.dark,
      },
      '&:active': {
        backgroundColor: theme.primary.darker,
        boxShadow: theme.buttonShadow(theme.primary.darker),
        color: theme.text.primary.dark,
      },
    },
    '&: active': {
      backgroundColor: theme.primary.darker,
      boxShadow: theme.buttonShadow(theme.primary.darker),
      color: theme.text.primary.dark,
    },
    'padding': '6px 16px', // Spacing around the button content
    'fontSize': '0.875rem',
  },
}));

export default useNotificationsPageStyles;
